













































































































































































import Component, { mixins } from 'vue-class-component';
import { currencyFormat, loadWidget } from '@/utils/helpers';
import { namespace } from 'vuex-class';
import { ICustomers, IPaginate, ISmsTransaction } from '@/types/types';
import timestamp from '@/filters/timestamp';
import { Watch } from 'vue-property-decorator';
import WidgetMixins from '@/mixins/WidgetMixins';
import DialogMixins from '@/mixins/DialogMixins';
import moment from 'moment';
import qs from 'qs';

const smsTransactionsModule = namespace('smsTransactions');
const customersModule = namespace('customers');

@Component({
  name: 'SmsTransactions',
  components: {
    InternetConnection: loadWidget('pages/InternetConnection'),
    ToolBar: loadWidget('widgets/ToolBar'),
    SnackBar: loadWidget('widgets/SnackBar'),
    EmptyPage: loadWidget('pages/EmptyPage'),
  },
  filters: {
    currencyFormat,
    timestamp,
  },
})
export default class SmsTransactions extends mixins(WidgetMixins, DialogMixins) {
  @smsTransactionsModule.Getter('getAllTransactions') transactions!: ISmsTransaction[];
  @smsTransactionsModule.Getter('getPagination') pagination!: IPaginate;
  @customersModule.Getter('getAllCustomers') customers!: ICustomers[];

  // The API returns newest-first; the initial sort mirrors that so the Date
  // column shows the descending indicator.
  options: any = { sortBy: ['createdAt'], sortDesc: [true] };
  query: string = '';
  statuses: string[] = ['ALL', 'PENDING', 'COMPLETED', 'SUCCESS', 'FAILED', 'CANCELLED'];
  startDateMenu: boolean = false;
  endDateMenu: boolean = false;

  startDate: string | null = null;
  endDate: string | null = null;
  status: string = 'ALL';
  userId: string | number | null = null;

  headers: Array<{ text: string; value: string; align?: string; sortable?: boolean }> = [
    { text: 'Date', value: 'createdAt' },
    { text: 'Ref.', value: 'reference' },
    { text: 'Customer', value: 'customerName' },
    { text: 'Channel', value: 'channel' },
    { text: 'Service', value: 'serviceProvider' },
    { text: 'Amount', value: 'amount', align: 'end' },
    { text: 'Status', value: 'status' },
  ];

  statusClass(status: string): string {
    const normalized = (status || '').toLowerCase();
    if (['success', 'completed', 'delivered'].includes(normalized)) return 'ka-status--success';
    if (['failed', 'rejected', 'expired', 'cancelled', 'incomplete', 'declined'].includes(normalized))
      return 'ka-status--error';
    if (normalized === 'pending') return 'ka-status--info';
    return 'ka-status--warning';
  }

  buildQuery(overrides: any = {}): string {
    const params: any = {
      page: this.pagination.page,
      size: this.pagination.itemsPerPage,
      ...(this.status !== 'ALL' && { status: this.status }),
      ...(this.userId !== null && { userId: this.userId }),
      ...(this.startDate && { startDate: this.startDate }),
      ...(this.endDate && { endDate: this.endDate }),
      ...overrides,
    };
    return qs.stringify(params, { skipNulls: true, addQueryPrefix: true });
  }

  fetchTransactions(): void {
    this.query = this.buildQuery();
    this.$store.dispatch('smsTransactions/list', this.query);
  }

  downloadFile(ext: string): void {
    this.query = this.buildQuery({ download: true, ext });
    this.$store.dispatch('smsTransactions/list', this.query);
  }

  @Watch('status')
  onStatusChange(): void {
    this.fetchTransactions();
  }

  @Watch('userId')
  onUserIdChange(): void {
    this.fetchTransactions();
  }

  @Watch('startDate')
  onStartDateChange(): void {
    this.fetchTransactions();
  }

  @Watch('endDate')
  onEndDateChange(): void {
    this.fetchTransactions();
  }

  @Watch('options', { deep: true })
  onOptionsChange(paginate: IPaginate): void {
    const query = this.buildQuery({ page: paginate.page, size: paginate.itemsPerPage });
    // The table re-fires this watcher remounting (skeleton swaps) — skip identical
    // queries to avoid a fetch loop, but still keep pagination state in sync.
    if (query === this.query) return;
    this.query = query;
    this.fetchTransactions();
  }

  created(): void {
    this.$store.dispatch('auth/me');
    this.$store.dispatch('customers/list', '?page=1&size=100');
    this.startDate = moment()
      .subtract(1, 'month')
      .format('YYYY-MM-DD');
    this.endDate = moment().format('YYYY-MM-DD');
    this.fetchTransactions();
  }
}
